// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_loader_container__1YRcp","loader":"loader_loader__M-FUL","spin":"loader_spin__u99fp"};